import { testDataOnStart } from "@/config/default";
import { TestDataBuffer } from "@/types";
import { createReducer, createAction, combineReducers } from "@reduxjs/toolkit";

const selectedItem: string = "";

type booleanAction = {
  type: string;
  payload: boolean;
};

type stringAction = {
  type: string;
  payload: string;
};

export const actionNames = {
  tab: "TAB",
  data: "DATA",
  text: "TEXT"
};

export const actions = {
  activeTab: createAction<string>(actionNames.tab),
  writeData: createAction<TestDataBuffer>(actionNames.data),
  writtenText: createAction<string>(actionNames.text)
};

const selectTab = (state = "", action: stringAction) => {
  const newState =
    action.type === actionNames.tab ? action.payload : state;
  return newState;
};

const writeData = (state = testDataOnStart, action: {type: string; payload: TestDataBuffer }) => {
  const newState =
    action.type === actionNames.data ? action.payload : state;
  return newState;
};

const writeText = (state = selectedItem, action: stringAction) => {
  const newState =
    action.type === actionNames.text ? action.payload : state;
  return newState;
};

export const RootReducer = combineReducers({
  selectedTab: selectTab,
  data: writeData,
  text: writeText
});

export type RootState = ReturnType<typeof RootReducer>;
